import AverageIdleChart from "./AverageIdleChart";
import DistanceChart from "./DistanceChart";
import ErrorChart from "./ErrorChart";
import ErrorRatioChart from "./ErrorRatioChart";
import LoadingChart from "./LoadingChart";
import ScheduleTotalChart from "./ScheduleTotalChart";
import ScheduleTypesChart from "./ScheduleTypesChart";
import TimeChart from "./TimeChart";
import TotalIdleChart from "./TotalIdleChart";
import { VCol, VRow } from "vuetify/lib";

export default {
	name: "DriversReportCharts",

	props: {
		item: Object,
		items: Array
	},

	render() {
		return <VRow class="k-charts" justify="center">
			<VCol class="k-chart-wrapper" cols={12} md={6} lg={4} xl={3}>
				<DistanceChart
					item={this.item}
					items={this.items}
				></DistanceChart>
			</VCol>

			<VCol class="k-chart-wrapper" cols={12} md={6} lg={4} xl={3}>
				<TimeChart
					item={this.item}
					items={this.items}
				></TimeChart>
			</VCol>

			<VCol class="k-chart-wrapper" cols={12} md={6} lg={4} xl={3}>
				<LoadingChart
					item={this.item}
					items={this.items}
				></LoadingChart>
			</VCol>

			<VCol class="k-chart-wrapper" cols={12} md={6} lg={4} xl={3}>
				<ScheduleTotalChart
					item={this.item}
					items={this.items}
				></ScheduleTotalChart>
			</VCol>

			<VCol class="k-chart-wrapper" cols={12} md={6} lg={4} xl={3}>
				<ScheduleTypesChart
					item={this.item}
					items={this.items}
				></ScheduleTypesChart>
			</VCol>

			<VCol class="k-chart-wrapper" cols={12} md={6} lg={4} xl={3}>
				<ErrorChart
					item={this.item}
					items={this.items}
				></ErrorChart>
			</VCol>

			<VCol class="k-chart-wrapper" cols={12} md={6} lg={4} xl={3}>
				<ErrorRatioChart
					item={this.item}
					items={this.items}
				></ErrorRatioChart>
			</VCol>

			<VCol class="k-chart-wrapper" cols={12} md={6} lg={4} xl={3}>
				<AverageIdleChart
					item={this.item}
					items={this.items}
				></AverageIdleChart>
			</VCol>

			<VCol class="k-chart-wrapper" cols={12} md={6} lg={4} xl={3}>
				<TotalIdleChart
					item={this.item}
					items={this.items}
				></TotalIdleChart>
			</VCol>
		</VRow>;
	}
};
